module.exports = __webpack_public_path__ + "static/media/close-green.b7ffa2d1.svg";